import { AbstractDocument } from './abstract-document.model';

export class Country {
    public code: string;
    public name: string;
}

export class Countries extends AbstractDocument {
    public list: Country[];
}